import { ChevronLeft } from "baseui/icon";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { SettingsCard } from "../../../../components/card/SettingsCard";
import { LottieLoading } from "../../../../components/graphics/LottieLoading";
import PlusSvg from "../../../../components/svg/PlusSvg";
import { useLazyGetPaymentMethodsQuery } from "../../../../services/BillingService";
import { getLinkedFirm } from "../../../../sessionStorage/sessionStorage";
import { PaymentMethod } from "../components/PaymentMethod";
import { PaymentMethodForm } from "../components/PaymentMethodForm";

export const PaymentMethods = () => {
  const navigate = useNavigate();

  const [getPaymentMethods, { data: paymentMethods, isLoading }] =
    useLazyGetPaymentMethodsQuery();

  const [isOpenAdd, setIsOpenAdd] = useState(false);

  useEffect(() => {
    void getPaymentMethods(getLinkedFirm()?.orgId);
  }, []);

  if (isLoading) {
    return <LottieLoading />;
  }

  return (
    <div className={"font-Manrope"}>
      <div className={"my-6 flex items-center gap-2"}>
        <SettingsIconButton
          hasShadow={false}
          icon={<ChevronLeft />}
          onClick={() => navigate(-1)}
        />
        <div className={"text-2xl font-semibold"}>Billing Settings</div>
      </div>

      <SettingsCard extraClasses={"w-full max-w-[500px]"}>
        <div className={"p-4 text-lg font-semibold"}>Payment Method</div>

        <div className={"mb-4 px-4"}>
          <button
            onClick={() => setIsOpenAdd(true)}
            className={
              "transitions-all flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-[#C8D2DE] bg-white px-4 text-sm font-semibold text-[#253747] duration-300 hover:border-[#798CA4] hover:bg-[#4C637B0D]"
            }>
            <PlusSvg />
            <span>Add Payment Method</span>
          </button>
        </div>

        <div className={"transition-all duration-300"}>
          {isOpenAdd && (
            <PaymentMethodForm
              onClose={() => setIsOpenAdd(false)}
              onSuccess={async () => {
                await getPaymentMethods(getLinkedFirm()?.orgId);
              }}
            />
          )}

          <div>
            {(paymentMethods || []).map((item) => (
              <PaymentMethod
                key={item.id}
                paymentMethod={item}
                getPaymentMethods={async () => {
                  await getPaymentMethods(getLinkedFirm()?.orgId);
                }}
              />
            ))}
          </div>
        </div>
      </SettingsCard>
    </div>
  );
};
